import { sortByTitle } from "@/shared/sorting";
import { FolderNode, FolderTreeSelectNode } from "./types";

// Тот же порядок, что в дереве ВНД: оба сортируют общим `sortByTitle`.
function sortNodes(nodes: FolderTreeSelectNode[]) {
  nodes.sort((a, b) => sortByTitle(a.title, b.title));

  for (const node of nodes) {
    if (node.children) {
      sortNodes(node.children);
    }
  }
}

export function foldersToTreeSelectNodes(
  folders: FolderNode[],
): FolderTreeSelectNode[] {
  const nodeMap = new Map<string, FolderTreeSelectNode>();

  for (const folder of folders) {
    nodeMap.set(folder.id, {
      value: folder.id,
      title: folder.name ?? "",
    });
  }

  const roots: FolderTreeSelectNode[] = [];

  for (const folder of folders) {
    const node = nodeMap.get(folder.id)!;
    const parent = folder.parentId ? nodeMap.get(folder.parentId) : undefined;

    if (parent) {
      (parent.children ??= []).push(node);
    } else {
      roots.push(node);
    }
  }

  sortNodes(roots);

  return roots;
}
